<template>
  <auth-page>
    <h2 class="brand-text">Finish Registration</h2>
    <p>for {{ fields.email }}</p>
    <b-form-group>
      <label class="sr-only" for="name-input">Full Name</label>
      <input
        v-validate="'required|alpha_spaces'"
        id="name-input"
        :disabled="saving"
        :class="{ 'is-invalid' : errors.has('name') || apiErrors.name.length}"
        class="form-control"
        type="text"
        name="name"
        placeholder="Full Name"
        @input="setName"/>
      <validation-errors :validation-errors="[errors.first('name')]"/>
      <span v-if="!errors.has('name')">
        <validation-errors :validation-errors="apiErrors.name"/>
      </span>
    </b-form-group>
    <b-form v-if="!success" @submit="onSubmit">
      <b-form-group>
        <label class="sr-only" for="password-input">Password</label>
        <input
          v-validate="'required|min:8|lowercase|uppercase|numberOrSpecial'"
          id="password-input"
          ref="password"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('password') || apiErrors.password.length}"
          class="form-control"
          type="password"
          name="password"
          placeholder="Password"
          @input="setPassword"/>
        <validation-errors :validation-errors="[errors.first('password')]"/>
        <span v-if="!errors.has('password')">
          <validation-errors :validation-errors="apiErrors.password"/>
        </span>
      </b-form-group>
      <b-form-group>
        <label class="sr-only" for="password_confirmation">Confirm Password</label>
        <input
          v-validate="'required|confirmed:password'"
          id="password_confirmation"
          ref="password_confirmation"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('password_confirmation') }"
          class="form-control"
          type="password"
          name="password_confirmation"
          data-vv-as="password"
          placeholder="Confirm Password"
          @input="setPasswordConfirmation"/>
        <validation-errors :validation-errors="[errors.first('password_confirmation')]"/>
      </b-form-group>
      <b-tooltip target="password-input" triggers="focus" placement="left">
        <password-rules/>
      </b-tooltip>
      <b-form-group>
        <b-button :disabled="disabled" type="submit" block variant="light">
          Submit
          <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
        </b-button>
      </b-form-group>
      <form-fail :form-errors="apiErrors.other"/>
    </b-form>
    <form-success :success="success">
      You've completed the registration process!
      <br>
      You may now use your password to
      <router-link :to="{name: 'login', query: {email: fields.email}}" style="text-decoration:underline">login</router-link>
    </form-success>
    <router-link :to="{name: 'login'}" class="link-light">
      <i class="fas fa-hand-point-left"></i>
      &nbsp;back to login
    </router-link>
  </auth-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import authPage from '../../templates/auth-page'
import formFail from '../../common/form/form-fail'
import passwordRules from '../../common/form/password-rules'
import validationErrors from '../../common/form/validation-errors'
import formSuccess from '../../common/form/form-success'

export default {
  components: {
    authPage,
    formFail,
    passwordRules,
    validationErrors,
    formSuccess
  },
  computed: {
    ...mapState('register/forms/finishRegistration', [
      'apiErrors',
      'success',
      'fields',
      'saving'
    ]),
    disabled () {
      return this.errors.any() || this.saving
    }
  },
  created () {
    if (this.$route.params.token) {
      this.$store.commit('register/forms/finishRegistration/setField', {
        field: 'token',
        value: this.$route.params.token
      })
    }

    if (this.$route.query.email) {
      this.$store.commit('register/forms/finishRegistration/setField', {
        field: 'email',
        value: this.$route.query.email
      })
    }
  },
  methods: {
    ...mapActions({
      finishRegistration: 'register/finishRegistration'
    }),
    onSubmit (e) {
      e.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.finishRegistration()
        }
      })
    },
    setName (e) {
      this.$store.commit('register/forms/finishRegistration/setField', {
        field: 'name',
        value: e.target.value
      })
    },
    setPassword (e) {
      this.$store.commit('register/forms/finishRegistration/setField', {
        field: 'password',
        value: e.target.value
      })
    },
    setPasswordConfirmation (e) {
      this.$store.commit('register/forms/finishRegistration/setField', {
        field: 'password_confirmation',
        value: e.target.value
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/auth/finish-registration.vue